import { translatesReplacements } from './config';
import { CustomEvents } from '@powerplay/common';
export class Translations {
    translationsObject;
    localRecursionPreventionSemafor = false;
    setTranslations(data, disciplineTranslatesReplacements) {
        this.translationsObject = { ...data };
        for (const [key] of Object.entries(this.translationsObject)) {
            this.translationsObject[key] = this.translationsObject[key].replace(/<\!--.*?-->/g, '');
            this.translationsObject[key] = this.translationsObject[key].replaceAll('{', '[');
            this.translationsObject[key] = this.translationsObject[key].replaceAll('}', ']');
        }
        const allTranslatesReplacements = [];
        allTranslatesReplacements.push(...translatesReplacements);
        allTranslatesReplacements.push(...disciplineTranslatesReplacements);
        allTranslatesReplacements.forEach((value) => {
            value.replace.forEach(element => {
                const text = this.translationsObject[value.text];
                if (text) {
                    this.translationsObject[value.text] = text.replace(element.original, element.new);
                }
            });
        });
        console.log('translations ********', this.translationsObject);
        if (!this.localRecursionPreventionSemafor) {
            this.localRecursionPreventionSemafor = true;
            window.dispatchEvent(new Event(CustomEvents.translations));
        }
        return this.translationsObject;
    }
    getTranslations() {
        return this.translationsObject;
    }
}
//# sourceMappingURL=Translations.js.map